import ImpactContent from "./ImpactContent";
import ImpactCards from "./ImpactCards";

function WarehouseImpactSection() {
  return (
    <section className="impact-section py-5 mb-30">
      <div className="container">
        <div className="row align-items-center gy-5">

          {/* LEFT CONTENT */}
          <div className="col-lg-6">
            <ImpactCards />
          </div>

          {/* RIGHT BOXES */}
          <div className="col-lg-6">
            <ImpactContent />
          </div>
        </div>
      </div>
     
    </section>
  );
}

export default WarehouseImpactSection;
